/**
 * @function openInTab open given link a new tab securely.
 *
 * @param {string} url url to open in new tab
 */
export const openInTab = (url) => {
  window.open(url, '_blank', 'noopener=yes,noreferrer=yes');
};
